import React from 'react';
import ClientGallery from '../gallery/ClientGallery';

// MobileClientCards now uses the same gallery view
// The gallery is responsive and works well on mobile devices
const MobileClientCards = ({ 
  clients, 
  onViewProfile,
  onRestoreClient,
  listMode = 'active',
  onEdit, 
  onDelete, 
  onAddClient,
  isLoading,
  emptyStateMessage
}) => {
  return (
    <ClientGallery
      clients={clients}
      onViewProfile={onViewProfile}
      onRestoreClient={onRestoreClient}
      listMode={listMode}
      onEdit={onEdit}
      onDelete={onDelete}
      onAddClient={onAddClient}
      isLoading={isLoading}
      emptyStateMessage={emptyStateMessage}
    />
  );
};

export default MobileClientCards;
